var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"id":""}},[_c('div',{staticClass:"pale-bg px-3 px-md-5"},[_c('Nav'),_c('Hero')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }